import { commonTestIds } from '../../utils/commonTestIds';
import DropdownButton from '../dropdown/dropdownButton';
import { Icons } from 'copyright-clearance-center-common-ui';
import { ReactElement } from 'react';

interface IActionBarProps {
	visibleActionsCount: number;
	children: ReactElement[];
}

const ActionBar: React.FunctionComponent<IActionBarProps> = props => {
	return (
		<div className="rup-btn-group" role="group" aria-label="Viewer menu">
			{props.children.slice(0, props.visibleActionsCount)}
			{props.children.length > props.visibleActionsCount && (
				<DropdownButton
					style={{ padding: '0.25rem 0' }}
					iconSvg={Icons.MoreIcon}
					className="rup-icon-btn rup-icon-btn--sm"
					testId={commonTestIds.actionBarDropdown}
				>
					{props.children.slice(props.visibleActionsCount)}
				</DropdownButton>
			)}
		</div>
	);
};

export default ActionBar;
